// extracted by mini-css-extract-plugin
export default {"verticalNavGroup":"VerticalNavGroup_verticalNavGroup__tjsbW"};